import React, { createContext, useContext } from 'react';

export const LeadModalContext = createContext({ openLeadModal: () => {} });

export const useLeadModal = () => useContext(LeadModalContext);
